
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Users } from 'lucide-react';
import { KoreksiMeter } from './Hublang/Cekmeter/KoreksiMeter';
import { PetugasMeter } from './Hublang/Cekmeter/PetugasMeter';
import { Pelanggan } from './Hublang/Cekmeter/Pelanggan';
import { KoreksiUmum } from './Hublang/Cekmeter/KoreksiUmum';
import { BacaMeter } from './Hublang/Cekmeter/BacaMeter';

export default function DashboardCekmeter() {
    const [menuStatus, setMenuStatus] = useState("koreksimeter");
    const [bulanBacaMeter, setBulanBacaMeter] = useState("01");
    const [tahunBacaMeter, setTahunBacaMeter] = useState("2025");

    return (
      <>
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
          <div className="max-w-8xl mx-auto">
            {/* Header */}
            <div className="mb-8">
              <div className="flex items-center mb-4">
                <Users className="w-8 h-8 text-blue-600 mr-3" />
                <div>
                  <h1 className="text-3xl font-bold text-gray-800">Hublang</h1>
                  <p className="text-gray-600">Koreksi Meter</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
                <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                  <button
                    onClick={() => setMenuStatus("koreksimeter")}
                    className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'koreksimeter' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'koreksimeter' ? 'blue' : 'gray'}-200 transition-colors`}
                  >
                    KOREKSI METER
                  </button>

                  <button 
                    onClick={() => setMenuStatus("koreksiumum")}
                    className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'koreksiumum' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'koreksiumum' ? 'blue' : 'gray'}-200 transition-colors`}>
                    KOREKSI UMUM
                  </button>

                  <button 
                    onClick={() => setMenuStatus("bacameter")}
                    className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'bacameter' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'bacameter' ? 'blue' : 'gray'}-200 transition-colors`}>
                    BACA METER
                  </button>

                  <button 
                    onClick={() => setMenuStatus("petugasmeter")}
                    className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'petugasmeter' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'petugasmeter' ? 'blue' : 'gray'}-200 transition-colors`}>
                    PETUGAS METER
                  </button>

                  <button 
                    onClick={() => setMenuStatus("photometer")}
                    className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'photometer' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'photometer' ? 'blue' : 'gray'}-200 transition-colors`}>
                    PHOTO METER
                  </button>
                </div>
              </div>
            </div>
  
            { menuStatus == "photometer" && <KoreksiMeter />}
            { menuStatus == "petugasmeter" && <PetugasMeter />}
            { menuStatus == "pelanggan" && <Pelanggan />}
            { menuStatus == "koreksiumum" && <KoreksiUmum />}
            { menuStatus == "koreksimeter" && <KoreksiMeter />}
            { menuStatus == "bacameter" && <BacaMeter />}
            <Outlet />

          </div>
        </div>
      </>
    )
}
